var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: {
      "row-clicked": _vm.onClickRow,
      "update:sortBy": function ($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event
      },
      "sort-changed": _vm.onSortChanged,
    },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (data) {
          return [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              !_vm.noAvatar
                ? _c(
                    "div",
                    { staticClass: "mr-2" },
                    [
                      _c("user-avatar", {
                        key: data.item.user.id,
                        attrs: { user: data.item.user, size: "40px" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "h4",
                  { staticClass: "mb-0" },
                  [
                    _c(
                      "b-link",
                      {
                        attrs: {
                          to: {
                            name: "admin-user",
                            params: { id: data.item.user.id.toString() },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(data.item.full_name) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
      },
      {
        key: "cell(company)",
        fn: function (data) {
          return [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                !_vm.noAvatar
                  ? _c("div", [
                      _vm._v(
                        "\n        " + _vm._s(data.item.company) + "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                data.item.user.is_hijacking
                  ? _c(
                      "b-badge",
                      { staticClass: "ml-3", attrs: { variant: "danger" } },
                      [_vm._v("Hijacking")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            data.item.user.is_active
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Active"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("Inactive"),
                ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }